module.exports = __webpack_public_path__ + "img/scatter.aa59c938.png";